import React, { useEffect, useState } from "react";
import { IntlProvider } from "react-intl"
import { ChakraProvider, extendTheme } from "@chakra-ui/react"
import useTranslation from "../hooks/useTranslation";
import useThemes from "../hooks/useThemes";
import defaultTheme from "../hooks/default-theme"


const Wrapper = ({ children }) => {
  let theme_ = {};
  const { locale, translation, fetchTranslation } = useTranslation()
  const { theme, fetchTheme } = useThemes()
  let error = ""

  try {
    theme_ = extendTheme(JSON.parse(process.env.THEME_CONFIG))
    error = "THEIS IS THE THEME" + theme_
  } catch (error) {
    theme_ = extendTheme(defaultTheme)
    error = "ERROR" + theme_
  }

  const [current_theme, setCurrentTheme] = useState(theme_)

  useEffect(() => {
    //Locale translations
    fetchTranslation()
    fetchTheme()
  }, [])

  // useEffect(() => {
  //   setCurrentTheme(theme)
  // }, [theme])


  // const final_theme = extendTheme({
  //   ...current_theme, 
  //   styles: {
  //     global: {
  //       body: {
  //         fontFamily: null,
  //         lineHeight: null,
  //         fontSize: null,
  //         fontColor: null,
  //         fontWeight: null,
  //       }
  //     }
  //   }
  // })

  return <ChakraProvider theme={theme}>
    <IntlProvider
      defaultLocale="en"
      locale={locale}
      messages={translation}>
      {children}
    </IntlProvider>
  </ChakraProvider>
}

export default Wrapper;